// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"6ca66c74","293":"599f9356","302":"529935f8","453":"a79a35fc","634":"9aaf4d06","635":"3235b4c7","791":"18ddd6a6","820":"3c6d141b","861":"5ae321a0","970":"4d8bb99d"}[chunkId] + ".chunk.js";
};